import { render } from "./MobileBottomNav.vue?vue&type=template&id=6b40ddd5&scoped=true"
import script from "./MobileBottomNav.vue?vue&type=script&lang=js"
export * from "./MobileBottomNav.vue?vue&type=script&lang=js"

import "./MobileBottomNav.vue?vue&type=style&index=0&id=6b40ddd5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b40ddd5"]])

export default __exports__